import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { posts } from "./AllPost";

const FullPost: React.FC = () => {
  const { buttonUrl } = useParams<{ buttonUrl: string }>();
  const post = posts.find((post) => post.buttonUrl === buttonUrl);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [buttonUrl]);

  if (!post) {
    return (
      <div className="container mx-auto mt-10 text-center">
        <h1 className="text-4xl mb-4">Post Not Found</h1>
        <p className="mb-6">
          The post you're looking for doesn't exist or has been removed.
        </p>
        <Link
          to="/"
          className="bg-[#c1282dff] hover:bg-[#606060] text-white inline-block py-2 px-4"
        >
          Return Home
        </Link>
      </div>
    );
  }

  return (
    <div className="container mx-auto mt-10">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full md:w-3/5 px-4">
          <h1 className="text-4xl mb-4">{post.title}</h1>
          {post.questionsAndAnswers && post.questionsAndAnswers.length > 0 && (
            <div className="mt-6">
              <h2 className="text-2xl mb-4">Interview with the artist:</h2>
              <div className="grid grid-cols-1 gap-4">
                {post.questionsAndAnswers.map((qna, index) => (
                  <div key={index} className="pb-4 pr-4">
                    <p className="font-bold">Q: {qna.question}</p>
                    <p>A: {qna.answer}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="w-full md:w-2/5 px-4">
          <div className="sticky top-10">
            <div dangerouslySetInnerHTML={{ __html: post.embedCode || "" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FullPost;
